// API Configuration
// Uses environment variable REACT_APP_API_URL if available, falls back to current domain

const getAPIBaseURL = () => {
  // Check for environment variable (CRA uses REACT_APP_* prefix)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Fallback to current domain
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;

  // For production on domain without port, just use domain
  if (!port || (port === '80' && protocol === 'http:') || (port === '443' && protocol === 'https:')) {
    return `${protocol}//${hostname}/api`;
  }

  // For development with port
  return `${protocol}//${hostname}:${port}/api`;
};

export const API_BASE_URL = getAPIBaseURL();

export default API_BASE_URL;
